var cloudinaryBaseUrls = {
  1: '//img.ving.se/image/upload',
  3: '//img.ving.no/image/upload',
  11: '//img.spies.dk/image/upload',
  15: '//img.tjareborg.fi/image/upload',
  18: '//img.globetrotter.se/image/upload'
};
var sunwingUrls = {
  1: '/web/concepts/sunwing-logo',
  3: '/web/concepts/sunwing-logo',
  11: '/web/concepts/sunwing-logo',
  15: '/web/concepts/sunwing-logo',
  18: '/web/concepts/sunwing-logo'
};
var sunprimeUrls = {
  1: '/web/concepts/sunprime-logo',
  3: '/web/concepts/sunprime-logo',
  11: '/web/concepts/sunprime-logo',
  15: '/web/concepts/sunprime-logo',
  18: '/web/concepts/sunprime-logo'
};
var obcUrls = {
  1: '/web/concepts/obc-logo',
  3: '/web/concepts/obc-logo',
  11: '/web/concepts/obc-logo',
  15: '/web/concepts/obc-logo',
  18: '/web/concepts/obc-logo'
};
var familyGardenUrls = {
  1: '/web/concepts/family-garden-hotels-logo',
  3: '/web/concepts/family-garden-hotels-logo',
  11: '/web/concepts/family-garden-hotels-logo',
  15: '/web/concepts/family-garden-hotels-logo',
  18: '/web/concepts/family-garden-hotels-logo'
};
var familyComfortUrls = {
  1: '/web/concepts/family-comfort-logo',
  3: '/web/concepts/family-comfort-logo',
  11: '/web/concepts/family-comfort-logo',
  15: '/web/concepts/family-comfort-logo',
  18: '/web/concepts/family-comfort-logo'
};
var primeComfortUrls = {
  1: '/web/concepts/prime-comfort-logo',
  3: '/web/concepts/prime-comfort-logo',
  11: '/web/concepts/prime-comfort-logo',
  15: '/web/concepts/prime-comfort-logo',
  18: '/web/concepts/prime-comfort-logo'
};
var primeSelectUrls = {
  1: '/web/concepts/prime-select-logo',
  3: '/web/concepts/prime-select-logo',
  11: '/web/concepts/prime-select-logo',
  15: '/web/concepts/prime-select-logo',
  18: '/web/concepts/prime-select-logo'
};
var sportUrls = {
  1: '/web/concepts/sport-logo',
  3: '/web/concepts/sport-logo',
  11: '/web/concepts/sport-logo',
  15: '/web/concepts/sport-logo',
  18: '/web/concepts/sport-logo'
};
var sportsClubUrls = {
  1: '/web/concepts/sport-sportsclub-logo',
  3: '/web/concepts/sport-sportsclub-logo',
  11: '/web/concepts/sport-sportsclub-logo',
  15: '/web/concepts/sport-sportsclub-logo',
  18: '/web/concepts/sport-sportsclub-logo'
};
var sportYogaUrls = {
  1: '/web/concepts/sport-yoga-logo',
  3: '/web/concepts/sport-yoga-logo',
  11: '/web/concepts/sport-yoga-logo',
  15: '/web/concepts/sport-yoga-logo',
  18: '/web/concepts/sport-yoga-logo'
};
var sportPadelUrls = {
  1: '/web/concepts/sport-padel-logo',
  3: '/web/concepts/sport-padel-logo',
  11: '/web/concepts/sport-padel-logo',
  15: '/web/concepts/sport-padel-logo',
  18: '/web/concepts/sport-padel-logo'
};
var sportCyclingUrls = {
  1: '/web/concepts/sport-cycling-logo',
  3: '/web/concepts/sport-cycling-logo',
  11: '/web/concepts/sport-cycling-logo',
  15: '/web/concepts/sport-cycling-logo',
  18: '/web/concepts/sport-cycling-logo'
};
var sportGolfUrls = {
  1: '/web/concepts/sport-golf-logo',
  3: '/web/concepts/sport-golf-logo',
  11: '/web/concepts/sport-golf-logo',
  15: '/web/concepts/sport-golf-logo',
  18: '/web/concepts/sport-golf-logo'
};
var sportHikingUrls = {
  1: '/web/concepts/sport-hiking-logo',
  3: '/web/concepts/sport-hiking-logo',
  11: '/web/concepts/sport-hiking-logo',
  15: '/web/concepts/sport-hiking-logo',
  18: '/web/concepts/sport-hiking-logo'
};
var sportMTBUrls = {
  1: '/web/concepts/sport-mtb-logo',
  3: '/web/concepts/sport-mtb-logo',
  11: '/web/concepts/sport-mtb-logo',
  15: '/web/concepts/sport-mtb-logo',
  18: '/web/concepts/sport-mtb-logo'
};
var sportRunningUrls = {
  1: '/web/concepts/sport-running-logo',
  3: '/web/concepts/sport-running-logo',
  11: '/web/concepts/sport-running-logo',
  15: '/web/concepts/sport-running-logo',
  18: '/web/concepts/sport-running-logo'
};
var sportTennisUrls = {
  1: '/web/concepts/sport-tennis-logo',
  3: '/web/concepts/sport-tennis-logo',
  11: '/web/concepts/sport-tennis-logo',
  15: '/web/concepts/sport-tennis-logo',
  18: '/web/concepts/sport-tennis-logo'
};
var sportActiveUrls = {
  1: '/web/concepts/sport-active-logo',
  3: '/web/concepts/sport-active-logo',
  11: '/web/concepts/sport-active-logo',
  15: '/web/concepts/sport-active-logo',
  18: '/web/concepts/sport-active-logo'
};
var sportDanceUrls = {
  1: '/web/concepts/sport-dance-logo',
  3: '/web/concepts/sport-dance-logo',
  11: '/web/concepts/sport-dance-logo',
  15: '/web/concepts/sport-dance-logo',
  18: '/web/concepts/sport-dance-logo'
};
var sportCampUrls = {
  1: '/web/concepts/sport-camp-logo',
  3: '/web/concepts/sport-camp-logo',
  11: '/web/concepts/sport-camp-logo',
  15: '/web/concepts/sport-camp-logo',
  18: '/web/concepts/sport-camp-logo'
};
var trainingHotelUrls = {
  1: '/web/concepts/traningshotell-se',
  3: '/web/concepts/traningshotell-no',
  11: '/web/concepts/traningshotell-dk',
  15: '/web/concepts/traningshotell-fi',
  18: '/web/concepts/traningshotell-se'
};
var selectionUrls = {
  active: '/web/concepts/selection-active',
  adultsOnly: '/web/concepts/selection-adults-only',
  cityFavourite: '/web/concepts/selection-city-favourite',
  family: '/web/concepts/selection-family',
  golf: '/web/concepts/selection-golf',
  hideaway: '/web/concepts/selection-hideaway',
  nordicFavourite: '/web/concepts/selection-nordic-favourite',
  popular: '/web/concepts/selection-popular',
  romantic: '/web/concepts/selection-romantic',
  top: '/web/concepts/selection-top',
  unique: '/web/concepts/selection-unique'
};

export { cloudinaryBaseUrls, familyComfortUrls, familyGardenUrls, obcUrls, primeComfortUrls, primeSelectUrls, selectionUrls, sportActiveUrls, sportCampUrls, sportCyclingUrls, sportDanceUrls, sportGolfUrls, sportHikingUrls, sportMTBUrls, sportPadelUrls, sportRunningUrls, sportTennisUrls, sportUrls, sportYogaUrls, sportsClubUrls, sunprimeUrls, sunwingUrls, trainingHotelUrls };
//# sourceMappingURL=imageUrls.js.map
